/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_filter_query: 'bizBookingMgt/set_filter_query',
    set_filter_word: 'bizBookingMgt/set_filter_word',
    set_filter_default: 'bizBookingMgt/set_filter_default',
}

// count state 必須是 Object
const state = {
    filterQuery: {
        group: '',
        member: '',
        county: '',
        district: '',
        rent: [0, 100000],
    },
    isDefault: false,
    filterWord: '',
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_BOOKING_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_BOOKING_MGT_FILTER_WORD: (state) => {
       return state.filterWord
    },
    GET_BIZ_BOOKING_MGT_FILTER_DEFAULT: (state) => {
       return state.isDefault
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    setBizBookingMgtFilter ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setBizBookingMgtFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setBizBookingMgtFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_default);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_filter_query](state, query){
        state.filterQuery = query
        state.isDefault = false
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_default](state){
        state.filterQuery = {
            group: '',
            member: '',
            county: '',
            district: '',
            rent: [0, 100000],
        }
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/bookingMgt/bookingMgt.js